import { render, staticRenderFns } from "./WxWeappItem.vue?vue&type=template&id=48ee85a0&scoped=true&"
import script from "./WxWeappItem.vue?vue&type=script&lang=js&"
export * from "./WxWeappItem.vue?vue&type=script&lang=js&"
import style0 from "./WxWeappItem.vue?vue&type=style&index=0&id=48ee85a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ee85a0",
  null
  
)

export default component.exports